import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'the_fac_paid_a_productivity_bonus'

export const dataPointDefinition = {
  retracedId: 'the_fac_paid_a_productivity_bonus',
  name: 'The facility paid a Productivity Bonus',
  description:
    'Consult applicable legal requirements before answering this question.\r\r\n\r\r\nIf there are applicable legal requirements and the facility has paid a Bonus, answer "Yes, in line with legal requirements".\r\r\n\r\r\nIf there are applicable legal requirements and the facility has NOT paid a Bonus, answer "No, out of line with legal requirements".\r\r\n\r\r\nIf there are no applicable legal requirements and the facility has paid a Bonus, answer "Yes, not legally required (voluntarily)".\r\r\n\r\r\nIf there are no applicable legal requirements and the facility has NOT paid a Bonus, answer "No, not legally required".',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes- in line with legal requirements',
      key: 'YES_IN_LINE_W_LEGAL_REQS',
      slcpIndex: 1,
      slcpOptionName: 'bonus',
    },
    {
      name: 'Yes- not legally required (voluntarily)',
      key: 'YES_NOT_LEGALLY_REQUIRED_VOLUNTARILY',
      slcpIndex: 2,
      slcpOptionName: 'bonus',
    },
    {
      name: 'No- not legally required',
      key: 'NO_NOT_LEGALLY_REQUIRED',
      slcpIndex: 3,
      slcpOptionName: 'bonus',
    },
    {
      name: 'No- out of line with legal requirements',
      key: 'NO_OUT_OF_LINE_W_LEGAL_REQS',
      slcpIndex: 4,
      slcpOptionName: 'bonus',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: [
          'YES_IN_LINE_W_LEGAL_REQS',
          'YES_NOT_LEGALLY_REQUIRED_VOLUNTARILY',
          'NO_NOT_LEGALLY_REQUIRED',
          'NO_OUT_OF_LINE_W_LEGAL_REQS',
        ],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wage-58',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8410,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
